// values for the name attribute
export const SIGNUP_FIELDS = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  JOB_TITLE: 'jobTitle',
  EMAIL: 'email',
  PHONE_NUMBER: 'phoneNumber',
  COMPANY_NAME: 'companyName',
  USERNAME: 'username',
  PASSWORD: 'password',
  CONFIRM_PASSWORD: 'passwordConfirm',
  COUNTRY: 'country',
  SELECT_COUNTRY: 'Select Country',
  ZIP_CODE: 'zipPostalCode',
};

export const SIGN_UP = 'Sign Up';
export const ACCEPT_TERMS = 'Accept Terms & Conditions';
export const AGE_NOTICE = 'You must be 18 or older to create an account.';
